<template>
  <div class="wrapper">

      <my-header class="no-print"></my-header>
      <div class="banner no-print">
        <div class="banner_txt">明德强技 实干笃学</div>
      </div>
      <div class="my_main">
        <el-row :gutter="20">
          <el-col :span="4">
            <my-menu class="no-print"></my-menu>
          </el-col>
          <el-col :span="20"><router-view/></el-col>
        </el-row>

      </div>


        <my-footer class="no-print"></my-footer>


  </div>
</template>

<script lang = "ts">
// import { } from "@ant-design/icons-vue";
// import { useRoute } from "vue-router";
import myMenu from "./menu.vue";
import myHeader from "./header.vue";
import myFooter from "./footer.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "",
  components: {
    myMenu,myHeader,myFooter
  },
  setup() {
    //*********** definning variables start **********//
    //*********** definning variables end **********//
    //*********** initData start **********//
    //*********** initData end **********//
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
  },
});
</script>
<style lang="scss">
.wrapper{
  .banner{
    height: 150px; width: 100%; background: url(../../assets/images/banner.png) #1890ff bottom no-repeat; color: #fff; font-size: 36px; font-weight: bold; padding-top: 50px; box-sizing: border-box;
    .banner_txt{width: 1200px; margin: 0 auto;}
  }
  .my_main{width: 1200px; margin: 0 auto; padding: 30px 0; background: #fafafa;}
  .el-footer{padding: 0;}
}
@media print {
  .el-col-4 {
    display: none;
  }
  .el-col-20 {
    max-width: 100% !important;
  }
}

</style>
